import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { CountryInterface } from '../data';
import { NormativeCountryProvider } from '../providers/normative-country.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetNormativeCountriesUseCase implements UseCase<Observable<Transaction<CountryInterface[]>>> {
    constructor(private normativeCountryProvider: NormativeCountryProvider) {}

    bind(): Observable<Transaction<CountryInterface[]>> {
        return this.normativeCountryProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (countries) => Transaction.success(cloneDeep(countries)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
